import { Autocomplete, Box, FormControl, IconButton, InputAdornment, Popover, TextField, Tooltip, Typography, Button, Popper, Checkbox, Dialog, DialogContent, SvgIcon } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import store, { RootState } from '../../../global/config/store.ts';
import { useShopperDetails } from '../../../global/ShopperDetailsUtils.ts';
import { setLoadingTrue } from '../../../global/config/Action/loadingActions.ts';
import { toast } from 'react-toastify';
import Icons from "../../../global/constants/icons.ts";
import { ApiChangeApproveAllocationsDate, ApiEditorClientEntities, ApiEditorVenueList, ApiGetAdminMonthlyAllocations, ApiGetClientEntityByClientGroupId, ApiGetVenueList, ApiPutShopperDetails, ApiReportTempToken, ApiResetBulkAllocation, ApiUpdateEarlyInvoice } from '../../../apiService/Core/Apicall.tsx';
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import dayjs, { Dayjs } from "dayjs";
import { Clear, PersonOutlined, Note, Edit, CancelOutlined, AttachMoneyOutlined, } from '@mui/icons-material';
import Dcrage from '../OrphanAllocation/Dcrage.tsx';
import venueclose from '../../../assets/images/veneu-close.png'
import venuemessage from '../../../assets/images/venuemessage.png'
import new_orange from '../../../assets/images/neworange.png'
import new_green from '../../../assets/images/newgreen.png'
import clogo from '../../../assets/images/c-logo.png'
import liqur from '../../../assets/images/liqur-glass.png'
import mmlogo from '../../../assets/images/MM_logo.png'
import aldilogo from '../../../assets/images/Aldi_logo.png'
import bloomslogo from '../../../assets/images/Blooms_logo.png'
import { setSelectedClientGroup } from '../../../global/config/Reducer/clientSlice.ts';
import { setDate } from '../../../global/config/Reducer/dateSlice.ts';
import { DateCalendar } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"


function useDebounce<T>(value: T, delay: number): T {
    const [debouncedValue, setDebouncedValue] = useState<T>(value);
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        return () => clearTimeout(timer);
    }, [value, delay]);
    return debouncedValue;
}

function WeeklyCalendar() {
    const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
    const selectedDateRedux = useSelector((state: RootState) => state.date.selectedDate)
    const dispatch = useDispatch()
    const [search, setSearch] = useState("");
    const [clientEntityList, setClientEntityList] = useState<any>([]);
    const [clientEntityId, setClientEntityId] = useState<string | null>(null);
    const [venueName, setVenueName] = useState([]);
    const [venueNameValue, setVenueNameValue] = useState<any>(null);
    const [allocations, setAllocations] = useState([]);
    const [selectedDate, setSelectedDate] = useState<any | Dayjs>(new Date(selectedDateRedux));
    const Clientlist = useSelector((state: RootState) => state.client.clientList);
    const [selectedClient, setSelectedClient] = useState<any>(selectedClientName);
    const [ClientId, setClientId] = useState(null);
    // const [anchorEl, setAnchorEl] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(null);
    // const [loanData, setLoanData] = useState();
    const [showNotes, setshowNotes] = useState<boolean>(false);
    const [selectedShopper, setSelectedShopper] = useState('');
    const [selectedNotes, setselectedNotes] = useState<number>();
    const navigate = useNavigate()
    const [fullText, setFullText] = useState('');
    const [fullText2, setFullText2] = useState('');
    const [staticLineInserted, setStaticLineInserted] = useState(false);
    const [staticLineInserted2, setStaticLineInserted2] = useState(false);
    const shoppernoteRef = useRef<HTMLTextAreaElement | null>(null);
    const trainingnoteRef = useRef<HTMLTextAreaElement | null>(null);
    const userRole: any = localStorage.getItem("userRole");
    const userId: any = localStorage.getItem("userId");
    const { anchorEl, loanData, clickedShopperId, handleShopperDetailsClick, handleClose } = useShopperDetails();
    const [isStartLoading, setisStartLoading] = useState(false);
    const itemRefs = useRef<(HTMLDivElement | null)[]>([]);
    const [index, setIndex] = useState<number>();
    const [events, setEvents] = useState<{ title: string; start: string }[]>([]);
    const [anchorEl2, setAnchorEl2] = useState<HTMLElement | null>(null);
    const [selectedAllocations, setSelectedAllocations] = useState<number[]>([]);
    const [open, setOpen] = useState(false);
    const [selectedNewDate, setSelectedNewDate] = useState<Dayjs | null>();
    const userName = localStorage.getItem('userName') || ""


    useEffect(() => {
        if (Clientlist.length > 2) {
            // setSelectedClient(Clientlist[2]);
            setClientId(Clientlist[2].clientGroupName);
        }
    }, [Clientlist]);

    useEffect(() => {
        setSelectedClient(selectedClientName)
    }, [selectedClientName])

    const debouncedClientEntityId = useDebounce(clientEntityId, 500);
    const debouncedVenue = useDebounce(venueNameValue, 700);

    const monthDays = useMemo(() => {
        const year = selectedDate.getFullYear();
        const month = selectedDate.getMonth();
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        return Array.from({ length: daysInMonth }, (_, i) => {
            const date = new Date(year, month, i + 1);
            return {
                fullDate: date.toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                }),
                weekday: date.toLocaleDateString("en-US", { weekday: "long" }),
                isoDate: date.toISOString(),
                month: date.toLocaleDateString("en-US", { month: "short" }),
                dayOfMonth: i + 1,
            };
        });
    }, [selectedDate]);

    useEffect(() => {
        // Only fetch client list on initial load
        handleGetClientList();
        // We'll handle allocation fetching in a separate effect
    }, []);

    // Add a new useEffect that will run when selectedClient is set initially
    useEffect(() => {
        if (clientEntityId) {
            handleGetAllocation();
        }
    }, [clientEntityId]);

    useEffect(() => {
        if (debouncedClientEntityId) {
            ApiCallGetVenueList(debouncedClientEntityId);
        } else {
            setVenueName([]);
            setVenueNameValue(null);
        }
    }, [debouncedClientEntityId]);

    useEffect(() => {
        if (clientEntityId === null) {
            setVenueName([]);
        }
    }, [clientEntityId]);

    useEffect(() => {
        if (selectedClient?.clientGroupName) {
            handleGetClientList()
        }
    }, [selectedClient?.clientGroupName])

    useEffect(() => {
        if (selectedClient && selectedDate) {
            // Only call if selectedClient exists
            const timeout = setTimeout(() => {
                handleGetAllocation();
            }, 300);

            return () => clearTimeout(timeout);
        }
    }, [debouncedVenue, selectedDate, selectedClient]);

    // const handleHover = async (event, index, item?: any) => {
    //   setAnchorEl(event.currentTarget);
    //   // Store the hovered row index
    //   try {
    //     const currentDate = new Date();
    //     const currentMonth = currentDate.getMonth() + 1; // Months are zero-based, so add 1
    //     const currentYear = currentDate.getFullYear();

    //     const data = `?userId=${item?.appliedData?.userId}&currentMonth=${currentMonth}&currentYear=${currentYear}`;

    //     // Call API to get shopper details
    //     const response = await ApiGetShopperPopUpDetails(data);

    //     if (!response.status) {
    //       toast.error("Failed to load shopper details");
    //       return;
    //     }

    //     // Set shopper details from API response
    //     setLoanData(response.data);
    //     setSelectedIndex(index);
    //   } catch (error) {
    //     //toast.error("Error loading shopper details");
    //   }
    // };

    // const handleClose = () => {
    //   setAnchorEl(null);
    //   setSelectedIndex(null);
    // };

    const handleGetAllocation = async () => {
        setisStartLoading(true)
        setAllocations([])
        store.dispatch(setLoadingTrue());
        const jobMonth = selectedDate.getMonth() + 1; // +1 because getMonth() returns 0-11
        const jobYear = selectedDate.getFullYear();

        let data = `?offset=0&limit=100&jobMonth=${jobMonth}&jobYear=${jobYear}`;
        if (venueNameValue) data += `&venueId=${venueNameValue}`;
        if (clientEntityId) data += `&clientEntityId=${clientEntityId}`;
        if (selectedClient?.clientGroupName !== 'All')
            data += `&allocationClientGroup=${selectedClient.clientGroupName}`;

        try {
            const res: any = await ApiGetAdminMonthlyAllocations(data);
            if (res.success) {
                setAllocations(res.data);
                setisStartLoading(false)
            }
        } catch (error) {
            const message =
                error?.response?.data?.message || // API error message
                error?.message ||                 // JS error message
                String(error);
            toast.error(message)
            console.error("Error during API call:", error);
            setisStartLoading(false)

        }
        finally {
            // store.dispatch(setLoadingFalse())
        }
    };


    const handleGetClientList = async () => {
        if (!selectedClient?.clientGroupName) return;
        const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`;
        const data2 = `?editorId=${userId}&ClientGroupName=${ClientId}`;

        try {
            const res: any = userRole == 3 ? await ApiEditorClientEntities(data2) : await ApiGetClientEntityByClientGroupId(data);
            setClientEntityList(res.data);
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const ApiCallGetVenueList = async (debouncedClientEntityId: string) => {
        const data = `?clientEntityId=${clientEntityId}&offset=0&limit=500&venueStatus=active`;
        const data2 = `?clientEntityId=${clientEntityId}&editorId=${userId}`;
        try {
            const res = userRole == 3 ? await ApiEditorVenueList(data2) : await ApiGetVenueList(data);
            const response = res?.data.map((item) => ({
                label: item.venueName,
                value: item.venueId,
            }));
            setVenueName(response);
        } catch (error) {
            console.error("Error fetching venue list:", error);
        }
    };

    const handleOnFocus = (e) => {

        if (!staticLineInserted) {
            e.preventDefault(); // prevent newline from default action
            const now = new Date();
            const formatted = now.toLocaleString(); // e.g., 7/14/2025, 12:35:10 PM
            const staticLine = `${userName}-${formatted}:\n`;
            const updatedText = `${staticLine}\n${fullText?.length > 1 ? `${fullText}\n` : ""}`; // add static line
            setFullText(updatedText);
            setStaticLineInserted(true);

            setTimeout(() => {
                const textarea = shoppernoteRef && shoppernoteRef.current;
                if (textarea) {
                    textarea.focus(); // ensure focus
                    textarea.setSelectionRange(staticLine.length, staticLine.length);
                }
            }, 0);

        }
    };
    const handleOnFocus2 = (e) => {

        if (!staticLineInserted2) {
            e.preventDefault(); // prevent newline from default action
            const now = new Date();
            const formatted = now.toLocaleString(); // e.g., 7/14/2025, 12:35:10 PM
            const staticLine = `${userName}-${formatted}:\n`;
            const updatedText = `${staticLine}\n${fullText2?.length > 1 ? `${fullText2}\n` : ""}`; // add static line
            setFullText2(updatedText);
            setStaticLineInserted2(true);

            setTimeout(() => {
                const textarea = trainingnoteRef && trainingnoteRef.current;
                if (textarea) {
                    textarea.focus(); // ensure focus
                    textarea.setSelectionRange(staticLine.length, staticLine.length);
                }
            }, 0);

        }
    };

    const handleChange = (e) => {
        setFullText(e.target.value);
    };
    const handleOpenNotes = (e, allocation) => {
        allocation?.shopperNotes !== null ? setFullText(allocation?.shopperNotes) : setFullText('');
        allocation?.trainingNotes !== null ? setFullText2(allocation?.trainingNotes) : setFullText2('');
        setStaticLineInserted(false);
        setStaticLineInserted2(false);
        setSelectedShopper(allocation.shopperName)
        setshowNotes(true);
        setselectedNotes(allocation.allocationId)
        setAnchorEl2(e.currentTarget);
    }

    const handleChangetraining = (e) => {
        setFullText2(e.target.value);
    };

    const handleEditScoreCard = (allocationId: any) => {
        navigate(`/createOrEditScoreCard/${allocationId}`, {
            state: { clientGroup: ClientId },
        });
    }
    const saveNotes = async (userId: any) => {
        try {
            const data = {
                userId: userId,
                shopperNotes: fullText,
                trainingNotes: fullText2,
            };
            const response = await ApiPutShopperDetails(data);

            toast.success("Shopper notes saved successfully");
            setshowNotes(false)
            await handleGetAllocation()
            setFullText('')
            setFullText2('')
        } catch (error) {
            console.error("Error saving shopper notes:", error);
            toast.error("Error saving shopper notes");
        }
    };

    const handleAllocationClick = (allocationId: string) => {
        const selectedMonth = selectedDate.getMonth() + 1; // 1-12
        const selectedYear = selectedDate.getFullYear();

        navigate(`/admin/allocation-details/${allocationId}`, {
            state: {
                forcedDate: selectedDate,
                isApproved: true
            },
        });
    };


    const OpenEditReport = async (item: any) => {
        try {
            const data = {
                ...(item?.reportHeaderId && { reportHeaderId: item?.reportHeaderId }),
                allocationId: item.allocationId,
                clientGroupName: item.allocationClientGroup
            }
            const res = await ApiReportTempToken(data)
            if (res.success) {
                sessionStorage.setItem('fromOriginalSite', 'true');
                window.open(`${process.env.REACT_APP_SHOPPER_SITE}?x-z-a=${res?.data?.token}`, '_blank');
            }
            else {
                toast.error(res?.message)
            }
        } catch (error: any) {
            toast.error(error?.message)
        }
    }

    const scrollToIndex = (_: any, newValue: any) => {
        setIndex(newValue);
        if (newValue !== null) {
            itemRefs.current[newValue - 1]?.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
    };


    useEffect(() => {
        if (allocations?.length > 0) {
            const formattedEvents =
                allocations
                    ?.filter((item: any) =>
                        search
                            ? (item?.venueName?.toLowerCase()?.includes(search?.toLowerCase()) ||
                                item?.shopperName?.toLowerCase()?.includes(search?.toLowerCase()))
                            : true
                    )
                    ?.sort((a: any, b: any) => {
                        const clientCompare = a?.clientEntityName?.localeCompare(b?.clientEntityName);
                        if (clientCompare !== 0) return clientCompare;

                        return a?.regionName?.localeCompare(b?.regionName);
                    })
                    .map((item: any, index) => ({
                        title: `${item?.venueId.venueName}`,
                        start: item?.selectedVisitDate?.split("T")[0],
                        extendedProps: {
                            item: item,
                            index: index
                        },
                    }));

            setEvents(formattedEvents);
        }
    }, [allocations, selectedDate, search]);

    const renderEventContent = (eventInfo: any) => {
        const mainallocation = eventInfo.event.extendedProps;
        const allocation = mainallocation.item
        const dateNumber = dayjs(allocation?.selectedVisitDate).date()
        // setFullText(allocation?.shopperNotes)
        // Determine card color based on reportStatus, checkInDateTime, and checkOutDateTime
        let cardColor = "#FFF1B3"; // Default color
        let fontColor = "#fff";

        if (allocation.reportStatus === "app" || allocation.reportStatus === "rel") {
            cardColor = 'grey'
        }
        else if (allocation.reportStatus === "con") {
            cardColor = 'skyblue'
            fontColor = 'black'
        }
        else if (allocation.reportStatus === "atc") {
            cardColor = 'purple'
            fontColor = 'white'
        }
        else {
            if (allocation?.checkOutDateTime) {
                cardColor = 'green'
                fontColor = 'white'
            }
            else if (allocation.checkInDateTime) {
                cardColor = 'yellow'
                fontColor = 'black'
            }
            else if (allocation.locationType === 'region') {
                cardColor = "pink";
                fontColor = 'black'
            }
            else {
                cardColor = "mediumslateblue";
                fontColor = 'white'
            }
        }


        const formatDuration = (start?: string | Date, end?: string | Date): string => {
            if (!start || !end) return '';
            const diffMs = new Date(end).getTime() - new Date(start).getTime();
            if (Number.isNaN(diffMs) || diffMs < 0) return '';

            const totalSeconds = Math.floor(diffMs / 1000);
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;

            if (totalSeconds < 60) return `${seconds}s`;
            if (hours === 0) return `${minutes}m`;
            if (minutes === 0) return `${hours}h`;
            return `${hours}h ${minutes}m`;
        };


        return (
            <div key={index} ref={(el) => (itemRefs.current[dateNumber] = el)} className="scheduleContainer w-100">
                {/* <div className="scheduleRight-slide"> */}
                <div className="card-container w-100 p-1">
                    <div
                        key={index}
                        className="event-card"
                        style={{
                            position: 'relative',
                            backgroundColor: cardColor,
                            border: "1px solid #CDCDCD",
                            width: "100%"
                        }}
                    >
                        <div className="event-info" style={{ width: '100%' }}>
                            <div className="w-100">
                                <Box justifyContent={'space-between'} className='d-flex mb-1 w-100 align-items-center justify-content-betweeen'>
                                    <div>
                                        {(allocation?.shouldBeDifferentDayFromPreviousMonth === true && dayjs(allocation?.lastJobVisitedDate).format('dddd') === dayjs(allocation?.selectedVisitDate).format('dddd')) ? (
                                            <p className="px-2 d-flex align-items-center gap-1 text-light py-1" style={{ background: 'rgb(246,154,92)', fontSize: "14px", width: 'fit-content', fontWeight: 'bold', borderRadius: '5px' }}><Clear sx={{ fill: 'red' }} />{dayjs(allocation?.selectedVisitDate).format('dddd')}</p>
                                        ) : ''}
                                        {parseInt(allocation?.isNeedToHideWeekend) ? (
                                            <p className="px-2 text-light py-1" style={{ width: 'fit-content', fontSize: "10px", background: 'rgb(246,154,92)', fontWeight: 'bold', borderRadius: '5px' }}>3M ALERT-WKEND</p>
                                        ) : ''}
                                        {parseInt(allocation?.isNeedToHideNonWeekend) ? (
                                            <p className="px-2 text-light py-1" style={{ width: 'fit-content', fontSize: "10px", background: 'rgb(246,154,92)', fontWeight: 'bold', borderRadius: '5px' }}>5M ALERT-WKDAY</p>
                                        ) : ''}
                                    </div>

                                    {/* <Tooltip title={"This is title"}><IconButton className="m-0 p-0"><ReportProblemOutlined sx={{ color: 'red' }} /></IconButton></Tooltip> */}
                                </Box>

                                <div onClick={() => handleAllocationClick(allocation?.allocationId)}>
                                    <div className="d-flex align-items-center mt-1 mb-1" style={{ gap: '10px' }}>
                                        <img
                                            src={allocation?.allocationClientGroup === "ALDI" ? aldilogo : allocation?.allocationClientGroup === "BLOOMS" ? bloomslogo : mmlogo}
                                            className="company-logo bg-light p-1"
                                            style={{
                                                borderRadius: "50px",
                                                height: "30px",
                                                width: "30px",

                                            }}
                                        />
                                        <p
                                            className="company-name"
                                            style={{ color: fontColor, textOverflow: "ellipsis", overflow: 'hidden', whiteSpace: 'nowrap' }}
                                        >
                                            {allocation?.venueName}{" "}
                                        </p>

                                        {/* <span
                              className="product-name"
                              style={{ color: fontColor, cursor: "pointer" }}
                              onMouseEnter={(e) => {
                                //setLoanData(item);
                                // handleHover(e, i, allocation);

                              }}
                            >
                              | {allocation?.shopperName}
                            </span> */}
                                    </div>
                                    <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                                        <p className="d-flex my-1 align-items-center" style={{ gap: '5px' }}>
                                            {allocation?.shopTypeName && <span className="border px-2 " style={{ borderRadius: '5px', fontSize: '12px', color: fontColor }}>{allocation?.shopTypeName}</span>}
                                            {allocation?.venueCode && <span className="border px-2 " style={{ borderRadius: '5px', fontSize: '12px', color: fontColor }}>{allocation?.venueCode}</span>}
                                            {allocation?.venueGroup && <span className="border px-2 " style={{ borderRadius: '5px', fontSize: '12px', color: fontColor }}>{allocation?.venueGroup}</span>}
                                        </p>
                                    </div>
                                    <p style={{ color: fontColor, fontSize: '14px', textOverflow: "ellipsis", overflow: 'hidden', whiteSpace: 'nowrap' }}><strong>E:</strong> {allocation?.editors}</p>
                                    <p className="mb-1" style={{ color: fontColor, fontSize: '14px', textOverflow: "ellipsis", overflow: 'hidden', whiteSpace: 'nowrap' }}>{allocation?.visitTimeInformation}</p>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center" style={{ width: "90%", gap: '8px' }}>
                                            {allocation?.regionName && (<p className="mb-1 p-1 px-2" style={{ borderRadius: "5px", maxWidth: '', color: fontColor, fontSize: '10px', textOverflow: "ellipsis", overflow: 'hidden', whiteSpace: 'nowrap', background: 'rgb(247,179,42)' }}>{allocation?.regionName}</p>)}
                                            <p className="mb-1 p-1 px-2" style={{ borderRadius: "5px", maxWidth: '', color: fontColor, fontSize: '10px', textOverflow: "ellipsis", overflow: 'hidden', whiteSpace: 'nowrap', background: allocation?.clientEntityName === 'Liquor ID' ? 'rgb(40,137,207)' : "rgb(247,179,42)" }}>{allocation?.clientEntityName}</p>
                                        </div>
                                        {allocation?.isFinalAcceptByShopper ? (<IconButton><img src={clogo} height={'24px'} width={'auto'} /></IconButton>) : ''}
                                    </div>
                                </div>
                                <div className="d-flex align-item-center flex-column justify-content-between mb-0" style={{ gap: "5px" }}>
                                    <div className="d-flex align-items-center" style={{ gap: '5px' }}>
                                        {/* <PersonOutlined sx={{ color: fontColor }} /> */}
                                        <Tooltip
                                            title={
                                                <Box>
                                                    {allocation?.shopperNotes && (
                                                        <Typography variant="body2">{allocation.shopperNotes}</Typography>
                                                    )}
                                                    {allocation?.trainingNotes && (
                                                        <Typography variant="body2">{allocation.trainingNotes}</Typography>
                                                    )}
                                                </Box>
                                            }
                                            arrow
                                        >
                                            <Box className='d-flex align-items-center' sx={{ gap: '5px' }}>
                                                <p
                                                    className={`event-time ${allocation?.userStatus !== "active" ? "px-2 bg-danger" : ''}`}
                                                    style={{ color: fontColor }}
                                                    onClick={(e) => handleShopperDetailsClick(e, allocation?.userId)}
                                                >
                                                    {allocation?.shopperName}
                                                </p>
                                                <p className="text-white">({formatDuration(allocation.checkInDateTime, allocation.checkOutDateTime)})</p>
                                            </Box>
                                        </Tooltip>
                                        <span className="event-time" style={{ fontWeight: 'bold' }}>{allocation?.userStatus !== "active" && `(${allocation?.userStatus})`}</span>
                                        {(allocation?.isAirTasker === 1 || allocation?.isAirTaskerJob === 1) ? (
                                            <Box
                                                sx={{
                                                    backgroundColor: "#2596be",
                                                    color: "#fff",
                                                    fontSize: "12px",
                                                    fontWeight: 600,
                                                    px: 1.2,
                                                    py: 0.3,
                                                    borderRadius: "6px",
                                                    display: "inline-block",
                                                }}
                                            >
                                                AIR
                                            </Box>
                                        ) : ""}
                                        {allocation?.isInvoiceCreated === 1 &&
                                            <Typography sx={{ backgroundColor: 'black', color: "white", fontWeight: '900', padding: '1px 6px', fontSize: "12px", borderRadius: "50px" }}>$</Typography>}
                                        {Number(allocation.totalReportCountOfShopper) < 2 &&
                                            (<img
                                                height='20px'
                                                src={Number(allocation.totalReportCountOfShopper) === 1 ? new_orange : new_green}
                                            />)}
                                    </div>
                                    <hr className='m-0 py-0' style={{ borderColor: fontColor }} />
                                    <div className="d-flex align-items-center justify-content-bewteen w-100 mt-0">

                                        <div className='w-50'>
                                            {(allocation?.sevenDaysAgoVenueOpen && allocation?.threeDaysAfterVenueClose) ? (
                                                <Tooltip title={<Box
                                                    component="div"
                                                    dangerouslySetInnerHTML={{
                                                        __html: `
                                        <p>DO NOT audit or mysteryshop this store between ${dayjs(allocation?.threeDaysAfterVenueClose).format('DD/MM/YYYY') ?? ""} and ${dayjs(allocation?.sevenDaysAgoVenueOpen).format("DD/MM/YYYY") ?? ""}</p>
                                        <p>${allocation?.venueMessage ?? ""}</p>
                                        `,
                                                    }}
                                                />}><IconButton className="m-0 p-0"><img src={venuemessage} height={'24px'} width={'auto'} /></IconButton></Tooltip>
                                            ) : ''}
                                            {(allocation?.venueMessage && !allocation?.sevenDaysAgoVenueOpen && !allocation?.threeDaysAfterVenueClose) ? (
                                                <Tooltip title={<Box
                                                    component="div"
                                                    dangerouslySetInnerHTML={{
                                                        __html: `
                                        <p>${allocation?.venueMessage ?? ""}</p>
                                        `,
                                                    }}
                                                />}><IconButton className="m-0 p-0"><img src={venueclose} height={'24px'} width={'auto'} /></IconButton></Tooltip>
                                            ) : ''}
                                        </div>
                                        <div className='w-50 d-flex justify-content-end' style={{ gap: '8px' }}>

                                            <Checkbox
                                                className='px-0'
                                                sx={{
                                                    color: "#FFFFFF",
                                                    "&.Mui-checked": {
                                                        color: "#FFFFFF",
                                                    },
                                                }}
                                                checked={selectedAllocations.some(
                                                    (a: any) => a.allocationId === allocation.allocationId
                                                )}
                                                onChange={(e) =>
                                                    handleCheckboxChange(e, {
                                                        allocationId: allocation.allocationId,
                                                        userId: allocation.userId,
                                                    })
                                                }
                                            />
                                            {allocation?.isAldiLiquor ? (<IconButton className="m-0 p-0">
                                                <img src={liqur} height={'20px'} width={'auto'} />
                                            </IconButton>) : ''}
                                            <Tooltip title='notes'>
                                                <IconButton className="m-0 p-0">
                                                    <Note onClick={(e) => { handleOpenNotes(e, allocation); }} sx={{ color: 'lime' }} height='16px' />
                                                </IconButton>
                                            </Tooltip>
                                            {allocation?.reportStatus !== null && (
                                                <Tooltip title='edit report'><IconButton className="m-0 p-0" onClick={() => { OpenEditReport(allocation) }}
                                                >
                                                    <Edit color={fontColor} height='16px' />
                                                </IconButton></Tooltip>)}
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>


                    </div>

                    <Popper
                        open={showNotes && selectedNotes === allocation.allocationId}
                        anchorEl={anchorEl2}
                        placement="right-start"
                        style={{ zIndex: 1500, minHeight: '500px', minWidth: "500px", backgroundColor: 'white', borderRadius: '10px' }}
                        className='p-1'

                    >
                        <Box>

                            <Box className='mt-0 pt-0'>
                                <Box className='d-flex justify-content-end m-0 p-0'>
                                    <IconButton onClick={() => { setshowNotes(false); setselectedNotes(0) }}><CancelOutlined /></IconButton>
                                </Box>
                                <Box className='mb-2'>
                                    <Typography variant="h6" fontWeight='bold' bgcolor='#75724C' className="py-1 text-center text-light">Shopper Notes</Typography>
                                    <Box className='p-1'>
                                        <textarea
                                            className="border-0"
                                            value={fullText}
                                            ref={shoppernoteRef}
                                            onFocus={handleOnFocus}
                                            onChange={handleChange}

                                            rows={8}
                                            style={{
                                                width: '100%',
                                                boxShadow: '1px 1px 3px black',
                                                fontSize: '14px',
                                                padding: '8px',
                                            }}
                                        />
                                    </Box>
                                </Box>
                                <Box>
                                    <Typography variant="h6" fontWeight='bold' bgcolor='#75724C' className="py-1 text-center text-light">Training Notes</Typography>
                                    <Box className='p-1'>
                                        <textarea
                                            className="border-0"
                                            ref={trainingnoteRef}
                                            value={fullText2}
                                            onFocus={handleOnFocus2}
                                            onChange={handleChangetraining}

                                            rows={8}
                                            style={{
                                                width: '100%',
                                                boxShadow: '1px 1px 3px black',
                                                fontSize: '14px',
                                                padding: '8px',
                                            }}
                                        />
                                    </Box>
                                </Box>
                                <Box className='d-flex justify-content-center my-3'>
                                    <Button className="py-1 px-4" onClick={() => { saveNotes(allocation?.userId) }} sx={{ backgroundColor: '#75724C', color: 'white' }}>Save</Button>
                                </Box>
                            </Box>
                        </Box>
                    </Popper>
                    <Popover
                        open={Boolean(anchorEl) && selectedIndex === index}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "center",
                        }}
                    >
                        <Dcrage handleClose={handleClose} loanData={loanData} />
                    </Popover>

                </div>
                {/* </div> */}
            </div>
        )

    }

    useEffect(() => {
        if (selectedDateRedux) {
            setSelectedDate(new Date(selectedDateRedux))
        }
    }, [selectedDateRedux])

    const handleCheckboxChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        allocation: { allocationId: number; userId: number }
    ) => {
        setSelectedAllocations((prev: any) => {
            if (e.target.checked) {
                if (!prev.some((a: any) => a.allocationId === allocation.allocationId)) {
                    return [...prev, allocation];
                }
                return prev;
            } else {
                return prev.filter((a: any) => a.allocationId !== allocation.allocationId);
            }
        });
    };
    console.log("Selected CheckBox", selectedAllocations);

    const handleResetDetails = async () => {
        // setshowdateselect(true)
        try {
            const data = {
                allocations: selectedAllocations,
            }
            const res = await ApiResetBulkAllocation(data)
            toast.success(res.message)
            setSelectedAllocations([])
            handleGetAllocation();
        } catch (error) {
            const message =
                error?.response?.data?.message ||
                error?.message ||
                String(error);
            toast.error(message)
        }
    }
    const handleUpateDetails = async () => {
        try {
            const data = {
                allocationIds: selectedAllocations.map((item: any) => item.allocationId),
                dateToMove: dayjs(selectedNewDate).date(),
                monthToMove: dayjs(selectedNewDate).month() + 1,
                yearToMove: dayjs(selectedNewDate).year()
            }
            const res = await ApiChangeApproveAllocationsDate(data)
            toast.success("Allocation Moved Successfully.")
            setOpen(false)
            setSelectedAllocations([]);
            handleGetAllocation();
        } catch (error) {
            const message =
                error?.response?.data?.message ||
                error?.message ||
                String(error);
            toast.error(message)
        }
    }

    const updateAllocationInvoice = async (allocationId: number[], status) => {
        try {
            const data = {
                allocationIds: allocationId,
                isNeedToDoUnpaid: status

            }
            const res = await ApiUpdateEarlyInvoice(data)
            if (res.status) {
                handleGetAllocation()
            }
        } catch (error: any) {
            const message =
                error?.response?.data?.message ||
                error?.message ||
                String(error);
            toast.error(message)
        }
    }

    return (
        <div style={{ backgroundColor: "white", padding: "16px", position: "relative" }}>
            <Box sx={{ position: 'sticky', top: '0px', zIndex: '99', background: "white !important" }}>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between", // push items to edges
                        alignItems: "center",
                        gap: "8px",
                        marginBottom: "16px",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            flexWrap: "wrap",
                        }}
                    >
                        <span style={{ fontWeight: 500 }}>Code :</span>
                        {[
                            { label: "Approved - Metro", color: "mediumslateblue" },
                            { label: "Approved - Regional", color: "pink" },
                            // { label: "Approv (SAFETY)", color: "#F9C74F" },
                            { label: "CheckedIn", color: "yellow" },
                            { label: "Checkout", color: "green" },
                            { label: "Report Submitted", color: "skyblue" },
                            { label: "Approve to client", color: "purple" },
                            { label: "Report Approved", color: "gray" },
                        ].map((item, idx) => (
                            <div
                                key={idx}
                                style={{
                                    backgroundColor: item.color,
                                    color: ["yellow", "pink", "hotpink", "skyblue"].includes(
                                        item.color
                                    )
                                        ? "#000"
                                        : "#fff",
                                    padding: "4px 8px",
                                    borderRadius: "4px",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                }}
                            >
                                {item.label}
                            </div>
                        ))}
                    </div>

                    <div>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                views={["year", "month"]}
                                openTo="month"
                                label="Select Month"
                                value={selectedDate}
                                onChange={(newValue) => { newValue && setSelectedDate(newValue); dispatch(setDate(newValue)) }}
                                sx={{ width: 250 }}
                            />
                        </LocalizationProvider>
                    </div>
                </div>

                <Box className="d-flex justify-content-end align-items-center" gap={1}>
                    <Button
                        variant='contained'
                        className='table-row-background'
                        onClick={() => {
                            const isconfirm = window.confirm("Are you sure you want to mark selected allocations as paid ")
                            if (isconfirm) {
                                updateAllocationInvoice(selectedAllocations.map((item: any) => item.allocationId), false)
                            }
                        }}
                    >
                        Paid
                    </Button>
                    <Button
                        variant='contained'
                        className='table-row-background'
                        onClick={() => {
                            const isconfirm = window.confirm("Are you sure you want to mark selected allocations as unpaid ")
                            if (isconfirm) {
                                updateAllocationInvoice(selectedAllocations.map((item: any) => item.allocationId), true)
                            }
                        }}
                    >
                        Unpaid
                    </Button>
                    <Button
                        variant='contained'
                        className='table-row-background'
                        onClick={() => {
                            const isConfirmed = window.confirm("Are You Sure You Want To Reset ?")
                            if (isConfirmed) {
                                handleResetDetails()
                            }

                        }}
                    >
                        Reset
                    </Button>
                    <Button
                        variant='contained'
                        className='table-row-background'
                        onClick={() => setOpen(true)}
                    >
                        Update
                    </Button>
                </Box>

                <div
                    style={{ display: "flex", justifyContent: "center", margin: "24px 0" }}
                >
                    {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            views={["year", "month"]}
            label="Select Month"
            value={selectedDate}
            onChange={(newValue) => newValue && setSelectedDate(newValue)}
            sx={{ width: 250 }}
          />
        </LocalizationProvider> */}
                </div>

                <div className="scheduleContainer">
                    <div className="scheduleRight-slide">
                        <div className="card-container">
                            <div
                                style={{
                                    display: "flex",
                                    gap: "16px",
                                    width: "100%",
                                    justifyContent: "space-between",
                                }}
                            >
                                <div style={{ width: "50%" }}>
                                    <TextField
                                        variant="outlined"
                                        placeholder="Search here..."
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                        sx={{
                                            borderRadius: "10px",
                                            "& fieldset": {
                                                borderRadius: "10px",
                                            },
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <img src={Icons.searchNormal || "/placeholder.svg"} />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </div>
                                {/* <div style={{ width: "50%" }}> */}
                                <FormControl fullWidth>
                                    <Autocomplete
                                        disablePortal
                                        options={[
                                            ...new Set(
                                                allocations
                                                    .map((alloc: any) => dayjs(alloc.selectedVisitDate).isValid() ? dayjs(alloc.selectedVisitDate).date() : null)
                                                    .filter((day): day is number => day !== null) // remove null/NaN
                                            )
                                        ].sort((a, b) => a - b)} sx={{ width: 300 }}
                                        value={index}
                                        onChange={scrollToIndex}
                                        renderInput={(params) => <TextField {...params} InputLabelProps={{ sx: { opacity: 1, color: "text.primary" }, }} label='Select Date' />}
                                    />
                                </FormControl>
                                {/* </div> */}
                                <div style={{ display: "flex", gap: "16px", width: "100%" }}>
                                    <FormControl fullWidth>
                                        <Autocomplete
                                            // options={Clientlist}
                                            options={[...Clientlist, { clientGroupName: "All", clientGroupDBName: "all" }]}
                                            value={selectedClient}
                                            getOptionLabel={(option: any) =>
                                                option?.clientGroupName || ""
                                            }
                                            isOptionEqualToValue={(option, value) =>
                                                option?.clientGroupDBName === value?.clientGroupDBName
                                            }
                                            // onChange={(event, newValue) => {
                                            //   // setSelectedClient(newValue);
                                            //   dispatch(setSelectedClientGroup(newValue));
                                            //   setClientId(newValue?.clientGroupName || null);

                                            //   if (
                                            //     !newValue ||
                                            //     (selectedClient &&
                                            //       newValue.clientGroupName !==
                                            //       selectedClient.clientGroupName)
                                            //   ) {
                                            //     setClientEntityId(null);
                                            //     setVenueNameValue(null);
                                            //     setClientEntityList([]);
                                            //   }
                                            // }}
                                            onChange={(event, newValue) => {
                                                if (newValue?.clientGroupDBName === "all") {
                                                    // Handle "All" manually without dispatch
                                                    setSelectedClient(newValue);
                                                    // setClientId("All");
                                                    setClientEntityId(null);
                                                    setVenueNameValue(null);
                                                    setClientEntityList([]);
                                                } else {
                                                    // Normal case → use dispatch
                                                    dispatch(setSelectedClientGroup(newValue));
                                                    setClientId(newValue?.clientGroupName || null);

                                                    // if (
                                                    //     !newValue ||
                                                    //     (selectedClient &&
                                                    //         newValue.clientGroupName !== selectedClient.clientGroupName)
                                                    // ) {
                                                    setClientEntityId(null);
                                                    setVenueNameValue(null);
                                                    setClientEntityList([]);
                                                    // }
                                                }
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Client"
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        sx: { color: "text.primary" },
                                                    }}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: <>{params.InputProps.endAdornment}</>,
                                                    }}
                                                />
                                            )}
                                        />
                                    </FormControl>

                                    <FormControl fullWidth>
                                        <Autocomplete
                                            disablePortal
                                            options={clientEntityList.filter(
                                                (item) => item.clientEntityId !== null
                                            )}
                                            getOptionLabel={(option) => option?.entityName || ""}
                                            onChange={(event, newValue: any) => {
                                                setClientEntityId(newValue?.clientEntityId || null);
                                                if (!newValue) setVenueNameValue(null);
                                            }}
                                            value={
                                                clientEntityList.find(
                                                    (option) => option?.clientEntityId === clientEntityId
                                                ) || null
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Business"
                                                    InputLabelProps={{
                                                        sx: { opacity: 1, color: "text.primary" },
                                                    }}
                                                />
                                            )}
                                        />
                                    </FormControl>

                                    <FormControl fullWidth>
                                        <Autocomplete
                                            disablePortal
                                            options={venueName}
                                            value={
                                                venueName.find(
                                                    (option: any) => option.value === venueNameValue
                                                ) || null
                                            }
                                            onChange={(event, newValue: any) =>
                                                setVenueNameValue(newValue?.value)
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Sites"
                                                    InputLabelProps={{
                                                        sx: { opacity: 1, color: "text.primary" },
                                                    }}
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Box>
            <Box className='fullcalendar'>
                <FullCalendar
                    // height={'calc(100vh - 300px)'}
                    plugins={[dayGridPlugin]}
                    initialView="dayGridMonth"
                    key={selectedDate.toISOString().split("T")[0]}
                    initialDate={selectedDate.toISOString().split("T")[0]}
                    showNonCurrentDates={false}
                    events={events}
                    eventContent={renderEventContent}
                    eventBackgroundColor="transparent"
                    eventBorderColor="transparent"
                />
            </Box>
            <Popover
                open={Boolean(anchorEl) && clickedShopperId !== null}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
            >
                <Dcrage handleClose={handleClose} loanData={loanData} />
            </Popover>
            {isStartLoading && (
                <div
                    className="loader-overlay"
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        // background: 'rgba(0, 0, 0, 0.8)',
                        zIndex: 9999,
                    }}
                >
                    <div
                        style={{
                            border: '4px solid rgba(103, 107, 65, 1)',
                            borderRadius: '50%',
                            borderTop: '4px solid white',
                            width: 35,
                            height: 35,
                            animation: 'spin 0.6s linear infinite',
                        }}
                    ></div>

                    <style>
                        {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}
                    </style>
                </div>
            )}
            <Dialog open={open}>
                <DialogContent>
                    <Box className='d-flex align-items-center justify-content-end'>
                        <IconButton onClick={() => { setOpen(false) }}><CancelOutlined /></IconButton>
                    </Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateCalendar
                            minDate={dayjs(selectedDate).startOf("month")}
                            maxDate={dayjs(selectedDate).endOf("month")}
                            value={selectedNewDate}
                            //    views={["month", "year"]}   
                            onChange={(newValue) => setSelectedNewDate(newValue)}
                        />
                    </LocalizationProvider>
                    <Box className='d-flex align-items-center justify-content-center'>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className="table-row-background"
                            onClick={() => { handleUpateDetails() }}
                        >Update</Button>
                    </Box>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default WeeklyCalendar
